import axios from "axios";
import { APP_SETTINGS } from "./env";

const currentDomain = window.location.hostname.split(".")[1];

let endpointToUse;

if (currentDomain === "azurewebsites") {
  endpointToUse = new URL(APP_SETTINGS.public_endpoint).origin;
} else {
  endpointToUse = new URL(APP_SETTINGS.private_endpoint).origin;
}
export const axiosInstance = axios.create({
  baseURL: endpointToUse,//,
  // baseURL: "http://localhost:8000",
});

axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("accessToken");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (
      error.response &&
      error.response.status === 401 &&
      !originalRequest._retry
    ) {
      originalRequest._retry = true;

      try {
        const refreshToken = localStorage.getItem("refreshToken");
        if (!refreshToken) {
          throw new Error("No refresh token available");
        }

        const refreshResponse = await axios.post(
          `${endpointToUse}/auth/refresh-token`,//",
          // `http://localhost:8000/auth/refresh-token`,//",
          {
            refresh_token: refreshToken,
          }
        );

        if (refreshResponse.status === 200) {
          const newAccessToken = refreshResponse.data.accessToken;
          localStorage.setItem("accessToken", newAccessToken);

          // Update the Authorization header and retry the original request
          originalRequest.headers.Authorization = `Bearer ${newAccessToken}`;
          return axiosInstance(originalRequest);
        }
      } catch (refreshError) {
        console.error("Refresh token failed", refreshError);
        localStorage.removeItem("accessToken");
        localStorage.removeItem("refreshToken");
        window.location.href = "/login"; // Redirect to login page
        return Promise.reject(refreshError);
      }
    }

    return Promise.reject(error);
  }
);
